"use strict";
// NOTE : subaccounting platform currently does not support acats transfer distinction
// or support exchanges (treats them as buys and sells)
// so no mapping onto those types is supported;  expect those in the future
exports.__esModule = true;
exports.DateableTransactionType = void 0;
var DateableTransactionType;
(function (DateableTransactionType) {
    DateableTransactionType["regBuy"] = "regBuy";
    DateableTransactionType["regSell"] = "regSell";
    DateableTransactionType["planBuy"] = "planBuy";
    DateableTransactionType["planSell"] = "planSell";
    //exchangeOut = 'exchangeOut',
    //exchangeIn = 'exchangeIn',
    DateableTransactionType["transferOut"] = "transferOut";
    DateableTransactionType["transferIn"] = "transferIn";
    //acatsOut = 'acatsOut',
    //acatsIn = 'acatsIn',
    DateableTransactionType["dollarOnly"] = "dollarOnly";
})(DateableTransactionType = exports.DateableTransactionType || (exports.DateableTransactionType = {}));
// ================================================================================================
